import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAvatar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 88,
	height: 88,
	viewBox: "0 0 88 88",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 88,
		height: 88,
		rx: 44,
		fill: "#D6D8F0"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M44.0003 44C42.167 44 40.5975 43.3472 39.292 42.0416C37.9864 40.7361 37.3337 39.1666 37.3337 37.3333C37.3337 35.5 37.9864 33.9305 39.292 32.625C40.5975 31.3194 42.167 30.6666 44.0003 30.6666C45.8337 30.6666 47.4031 31.3194 48.7087 32.625C50.0142 33.9305 50.667 35.5 50.667 37.3333C50.667 39.1666 50.0142 40.7361 48.7087 42.0416C47.4031 43.3472 45.8337 44 44.0003 44ZM30.667 57.3333V52.6666C30.667 51.7222 30.91 50.8541 31.3962 50.0625C31.8823 49.2708 32.5281 48.6666 33.3337 48.25C35.0559 47.3888 36.8059 46.743 38.5837 46.3125C40.3614 45.8819 42.167 45.6666 44.0003 45.6666C45.8337 45.6666 47.6392 45.8819 49.417 46.3125C51.1948 46.743 52.9448 47.3888 54.667 48.25C55.4725 48.6666 56.1184 49.2708 56.6045 50.0625C57.0906 50.8541 57.3337 51.7222 57.3337 52.6666V57.3333H30.667Z",
		fill: "#F8F9FE"
	})]
});
export default SvgAvatar;
